function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { utils } from 'ethers';
/**
 * @internal Intended for internal use - use it on your own risk
 */

export function warnOnInvalidCall(call) {
  if (!call) {
    return;
  }

  var contract = call.contract,
      method = call.method,
      args = call.args;
  console.warn("Invalid contract call: address=".concat(contract.address, " method=").concat(method, " args=").concat(args));
}
/**
 * @internal Intended for internal use - use it on your own risk
 */

export function encodeCallData(call, chainId) {
  if (!call) {
    return undefined;
  }

  var contract = call.contract,
      method = call.method,
      args = call.args;

  if (!contract.address || !method) {
    warnOnInvalidCall(call);
    return undefined;
  }

  try {
    return {
      address: contract.address,
      data: contract.interface.encodeFunctionData(method, args),
      chainId: chainId
    };
  } catch (_a) {
    warnOnInvalidCall(call);
    return undefined;
  }
}
/**
 * @internal Intended for internal use - use it on your own risk
 */

export function getUniqueCalls(requests) {
  var unique = [];
  var used = {};

  var _iterator = _createForOfIteratorHelper(requests),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var request = _step.value;

      if (!used["".concat(request.address.toLowerCase()).concat(request.data).concat(request.chainId)]) {
        unique.push(request);
        used["".concat(request.address.toLowerCase()).concat(request.data).concat(request.chainId)] = true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return unique;
}
/**
 * @internal Intended for internal use - use it on your own risk
 */

export function decodeCallResult(call, result) {
  if (!result || !call) {
    return undefined;
  }

  var value = result.value,
      success = result.success;

  try {
    if (success) {
      return {
        value: call.contract.interface.decodeFunctionResult(call.method, value),
        error: undefined
      };
    } else {
      var errorMessage = new utils.Interface(['function Error(string)']).decodeFunctionData('Error', value)[0];
      return {
        value: undefined,
        error: new Error(errorMessage)
      };
    }
  } catch (error) {
    return {
      value: undefined,
      error: error
    };
  }
}